import { useEffect } from 'react';

const GoogleAdsPixel = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GOOGLE_ADS_PIXEL_ID}`;
        script.async = true;
        document.head.appendChild(script);

        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }
        window.gtag = gtag;

        gtag('js', new Date());
        gtag('config', process.env.REACT_APP_GOOGLE_ADS_PIXEL_ID);
    }, []);

    return null;
};

export const trackGoogleConversion = ({
  sendTo,
  transactionId = '',
  url = '',
} = {}) => {
  const fireEvent = () => {
    const callback = () => {
      console.log('[Google Ads] ✅ Conversion callback executed');
      if (url) window.location = url;
    };

    try {
      window.gtag('event', 'conversion', {
        send_to: sendTo,
        transaction_id: transactionId,
        event_callback: callback,
      });

      console.log('[Google Ads] 🚀 Conversion event fired to:', sendTo);
    } catch (err) {
      console.error('[Google Ads] ❌ Error firing event:', err);
    }
  };

  if (typeof window.gtag !== 'undefined') {
    fireEvent();
  } else {
    console.warn('[Google Ads] ❌ gtag not ready, retrying...');
    const interval = setInterval(() => {
      if (typeof window.gtag !== 'undefined') {
        clearInterval(interval);
        fireEvent();
      }
    }, 300);
  }
};



export default GoogleAdsPixel;
